import React from 'react';
import { XIcon } from 'lucide-react';
import { painLines } from '../data/unstuckContent';
export function PainSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="pain-title" data-id="element-173" data-mp="38xes75nlc9o9">
      <div className="mx-auto max-w-5xl px-5" data-id="element-174" data-mp="2uxdrbq7bt28s">
        <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-175" data-mp="2yzqv492iiq2x">
          The problem
        </p>
        <h2 id="pain-title" className="mt-3 max-w-3xl font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-176" data-mp="2l82je6w6e3mh">
          How many more weekends are you going to waste like this?
        </h2>
        <p className="mt-4 max-w-2xl text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-177" data-mp="2b8bpo7ffvsng">
          You’re ambitious. You love your work. But nobody told you that you’d spend your
          weekends scrolling, avoiding what matters, and arriving at Monday with nothing
          done.{' '}
          <span className="text-ivory-100" data-id="element-178" data-mp="27ae033hrb4jj">
            It’s not lack of motivation. It’s lack of a system.
          </span>
        </p>

        <ul className="mt-8 grid gap-x-10 gap-y-0 border-y border-charcoal-600 sm:grid-cols-2" data-id="element-179" data-mp="3nlyvl69ymm69">
          {painLines.map(line => <li key={line.headline} className="flex items-start gap-3 border-b border-charcoal-600 py-4 last:border-b-0 sm:[&:nth-last-child(2)]:border-b-0" data-id="element-180" data-mp="5faqhgewtz0l">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-181" data-mp="38x2k0z8p2r0w" />
              <span data-id="element-182" data-mp="3ine1zpp7r0qs">
                <span className="block text-[14px] font-medium leading-snug text-ivory-100" data-id="element-183" data-mp="3inx90bdbs4q1">
                  {line.headline}
                </span>
                <span className="mt-1 block text-[13px] leading-snug text-muted" data-id="element-184" data-mp="2q5rzr0xh5chz">
                  {line.detail}
                </span>
              </span>
            </li>)}
        </ul>

        <p className="mt-8 max-w-2xl font-display text-lg italic leading-snug text-champagne sm:text-2xl" data-id="element-185" data-mp="p424lbvwluer">
          What if this were the last weekend you wasted like this?
        </p>
      </div>
    </section>;
}